import React from "react";
import { createUseStyles } from "react-jss";
import Container from "reactstrap/lib/Container";
import PlansBTableContainer from "Containers/PlansBTableContainer";
import Block from "ComponentsUI/Block";
import { Flex } from "ComponentsUI/helpers";
import { ActionTariffsSortSelect } from "ComponentsUI/ActionTariffsSortSelect";
import { HeaderTextSeo } from "ComponentsUI/SeoBlock";

const useStyles = createUseStyles((theme) => ({
	titleContainer: {
		padding: "0 0 15px 0",
	},
	[`@media (max-width: ${theme.media.sm})`]: {
		titleContainer: {
			flexDirection: "column",
			alignItems: "flex-start",
		},
	},
}));

const ActionTariffsContainer = ({ onFilterChange, ...props }) => {
	const { titleContainer } = useStyles();
	const texts = props.ApplicationModel.text;

	const tariffs = props.tariffsActionsPage;
	const header = texts.ACTIONS_TARIFFS;

	// Проверка на наличие тарифов у провайдера
	if (!tariffs.length) {
		return null;
	}

	return (
		<Block stub={props.isLoading} withoutBottomPadding={false}>
			<Container>
				<Flex
					alignItems={"center"}
					justifyContent={"space-between"}
					style={{ paddingBottom: "15px" }}
					rootClass={titleContainer}
				>
					<HeaderTextSeo
						header={props.seoBlock?.seoHeader || header}
						text={props.seoBlock?.seoText}
					/>
					<ActionTariffsSortSelect
						ApplicationModel={props.ApplicationModel}
						onFilterChange={(filter) => onFilterChange(filter)}
					/>
				</Flex>
			</Container>
			<div className="container" data-test="countRates" data-count={tariffs.length}>
				<PlansBTableContainer tariffs={tariffs} isActionRegion={true} pageName="action_region" />
				{/*<TariffsTable
                    datatest={props.datatest}
                    tableHeader={tableHeader}
                >

                    {tariffs.map(item => {
                        return (
                            <RecentlyConnectedRowContainer
                                key={item.id}
                                data={item}
                                isAction={true}
                            />
                        );
                    })}
                </TariffsTable>*/}
			</div>
		</Block>
	);
};

export default ActionTariffsContainer;
